import React, { useEffect, useState } from "react";
import { Button, useGetList, useGetOne, useCreate } from "react-admin";
import Card from "@mui/material/Card";
import CardContent from "@mui/material/CardContent";
import Typography from "@mui/material/Typography";
import parse from "html-react-parser";
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useNavigate } from "react-router-dom";

import {
  Loading,
  useNotify,
  useGetIdentity
} from "react-admin";

import { CircularProgress } from "@mui/material";
import { FormProvider, useForm } from "react-hook-form";
import InputCheckBoxField from "../../componets/common/InputComponents/InputCheckBoxField";
import SignaturePadComponent from "../../componets/common/SignaturePadComponent";
import { ErrorMessage } from "@hookform/error-message";

const TermsConditionLandLoardSetup = (props) => {

  const Identity = useGetIdentity();
  const { data, isLoading: isLoadingData } = useGetOne("getTermsConditionLandlord", {
    id: 2,
  });
  const [create, { isLoading, error }] = useCreate();
  const defaultFormValues = {
    signatureImage: "",
    agreeterms: false,
    TermsConditions: ""
  };
  const schema = yup.object().shape({
    agreeterms: yup
      .boolean()
      .oneOf([true], "You must accept the terms and conditions")
      .required("You must accept the terms and conditions"),
    signatureImage: yup.string().required("Signature is required"),


  });
  const notify = useNotify();
  const methods = useForm({
    defaultValues: defaultFormValues,
    resolver: yupResolver(schema),
    mode: "onChange",
  });
  useEffect(() => {
    methods.setValue('TermsConditions', data?.Description);
  }, [data?.Description])
  const navigate = useNavigate();
  const onSubmit = async (data) => {
    const sendData = {
      ...data,
      agreeterms: Number(data.agreeterms),
    };
    create("updatelandlordtandc", { data: sendData }, {
      onSuccess: (data) => {
        notify(`Terms and Conditions updated successfully.`, {
          type: "success",
          anchorOrigin: { vertical: "top", horizontal: "right" },
        });
        localStorage.setItem("TermAndConditionVefificationStatus", "1");
        navigate('/landloard/landLoardInbox', { replace: true });
      }
    });
  };



  return (
    <div
      className="container"
      style={{
        marginTop: "50px",
      }}
    >
      <Card>

        <CardContent>

          <Typography sx={{ fontSize: 14 }} color="text.secondary" gutterBottom>

            <b>Terms And Conditions</b>

          </Typography>
          <hr />

          {data?.Description ? parse(data?.Description) : ""}
          <div className="auth-form mr-t30">
            {/* {signatureImage && <img src={signatureImage} alt="signature" />} */}
            <FormProvider {...methods}>
              <form onSubmit={methods.handleSubmit(onSubmit)}>
                <div className="form-group cus-input-group mr-b20">
                  <InputCheckBoxField
                    notRequired={false}
                    label={"I Accept the terms and conditions"}
                    name={`agreeterms`}


                  />
                  <p style={{ color: 'red' }}><ErrorMessage errors={methods.formState.errors} name="agreeterms" /></p>
                </div>

                {/* <JSONTree data={{signatureImage, signatureText, signatureFont, signatureType,setSignatureTyped}} /> */}
                <SignaturePadComponent setSignatureImage={methods.setValue} />
                <br />
                <br />

                <p style={{ color: 'red' }}><ErrorMessage errors={methods.formState.errors} name="signatureImage" /></p>
                
                {isLoading ? (
                  <div className="static-d-info d-flex justify-content-center align-items-center mw-100">
                    <CircularProgress size="20px" />
                    <h5>&nbsp; &nbsp; Please wait...</h5>
                  </div>
                ) : (
                  <div className="d-flex justify-content-center align-items-center">
                    <button type="submit" className="l-btn-forgetPsd" style={{ backgroundColor: "rgb(45, 195, 232)", border: "rgb(45, 195, 232)" }}>
                      Submit
                    </button>
                  </div>
                )}
              </form></FormProvider>

          </div>
        </CardContent>
      </Card>

    </div>
  );
};

export default TermsConditionLandLoardSetup;